import React, { useState } from "react";
import ChannelSendPanel from "./ChannelSendPanel";
import { IconButton } from "../../components/ui";

const ChannelSendIcons = ({
  studentId,
  student = null,
  receiptId = null,
  isPortal = false,
  defaultEventType = "DUE_REMINDER",
  onSuccess,
}) => {
  const [openChannel, setOpenChannel] = useState(null);

  return (
    <>
      <div className="inline-flex items-center gap-1">
        <IconButton
          type="button"
          aria-label="Send WhatsApp"
          title="WhatsApp"
          variant="ghost"
          size="sm"
          className="h-8 w-8 rounded-full border border-emerald-200 bg-emerald-50 text-xs font-semibold text-emerald-700 hover:bg-emerald-100"
          onClick={() => setOpenChannel("WHATSAPP")}
        >
          WA
        </IconButton>
        <IconButton
          type="button"
          aria-label="Send SMS"
          title="SMS (coming soon)"
          variant="ghost"
          size="sm"
          className="h-8 w-8 rounded-full border border-blue-200 bg-blue-50 text-xs font-semibold text-blue-700 hover:bg-blue-100"
          onClick={() => setOpenChannel("SMS")}
        >
          SMS
        </IconButton>
        <IconButton
          type="button"
          aria-label="Send Email"
          title="Email (coming soon)"
          variant="ghost"
          size="sm"
          className="h-8 w-8 rounded-full border border-violet-200 bg-violet-50 text-xs font-semibold text-violet-700 hover:bg-violet-100"
          onClick={() => setOpenChannel("EMAIL")}
        >
          EM
        </IconButton>
      </div>

      {openChannel && (
        <ChannelSendPanel
          isOpen={!!openChannel}
          onClose={() => setOpenChannel(null)}
          channel={openChannel}
          studentId={studentId}
          student={student}
          receiptId={receiptId}
          isPortal={isPortal}
          defaultEventType={defaultEventType}
          onSuccess={onSuccess}
        />
      )}
    </>
  );
};

export default ChannelSendIcons;